import { Avatar } from "@material-ui/core"
import React from 'react'

const stringToHslColor = (str: string, s: number, l: number) => {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}

export const generateAvatar = (userName: string) =>
    <Avatar style={{ backgroundColor: stringToHslColor(userName, 30, 60) }} alt={userName}>{userName ? userName[0].toUpperCase() : ''}</Avatar>